<template>
  <div>
    <base-overlay :show="fetching">
      <b-form
        novalidate
        @submit.prevent="submitInfo"
      >
        <validation-observer ref="formRef">
          <b-card>
            <b-row>
              <b-col md="4">
                <validation-provider
                  #default="{ errors }"
                  name="IBAN"
                  rules="required"
                >
                  <b-form-group
                    label="IBAN"
                    label-for="iban"
                  >
                    <b-form-input
                      id="iban"
                      v-model="formData.iban"
                      placeholder="Enter IBAN"
                    />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="4">
                <validation-provider
                  #default="{ errors }"
                  name="Account Number"
                  rules="required"
                >
                  <b-form-group
                    label="Account Number"
                    label-for="account-number"
                  >
                    <b-form-input
                      id="account-number"
                      v-model="formData.accountNumber"
                      placeholder="Account Number"
                    />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <!-- <b-col md="4">
              <b-form-group
                label="Business Type"
                label-for="business-type"
              >
                <v-select
                  id="business-type"
                  v-model="businessData.businessType"
                  :clearable="false"
                  placeholder="Business Type"
                  :options="businessTypes"
                  :reduce="val => val.id"
                  :loading="fetchingBusinessTypes"
                  :disabled="fetchingBusinessTypes || isOtpStage"
                />
              </b-form-group>
            </b-col> -->
              <b-col md="4">
                <validation-provider
                  #default="{ errors }"
                  name="BIC/Swift Code"
                  rules="required"
                >
                  <b-form-group
                    label="BIC/Swift Code"
                    label-for="swift-bic"
                  >
                    <b-form-input
                      id="swift-bic"
                      v-model="formData.swift"
                      placeholder="BIC/Swift Code"
                    />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="4">
                <validation-provider
                  #default="{ errors }"
                  name="Account Owner"
                  rules="required"
                >
                  <b-form-group
                    label="Account Owner"
                    label-for="account-owner"
                  >
                    <b-form-input
                      id="account-owner"
                      v-model="formData.accountOwner"
                      placeholder="Account Owner"
                    />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="4">
                <validation-provider
                  #default="{ errors }"
                  name="Bank Name"
                  rules="required"
                >
                  <b-form-group
                    label="Bank Name"
                    label-for="bank-name"
                  >
                    <b-form-input
                      id="bank-name"
                      v-model="formData.bankName"
                      placeholder="Bank Name"
                    />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="4">
                <validation-provider
                  #default="{ errors }"
                  name="Account Type"
                  rules="required"
                >
                  <b-form-group
                    label="Account Type"
                    label-for="account-type"
                  >
                    <b-form-input
                      id="account-type"
                      v-model="formData.accountType"
                      placeholder="Account Type"
                    />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col
                md="4"
                class="d-flex align-items-center justify-content-center"
              >
                <b-button
                  block
                  variant="primary"
                  type="submit"
                  :disabled="submitting"
                >
                  <b-spinner
                    v-if="submitting"
                    small
                  />
                  <span v-else>Submit</span>
                </b-button>
              </b-col>
            </b-row>
          </b-card>
        </validation-observer>
      </b-form>
    </base-overlay>
  </div>
</template>

<script>
import {
  BCard,
  BForm,
  BFormInput,
  BFormGroup,
  BButton,
  BRow,
  BCol,
  BSpinner,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
// import vSelect from 'vue-select'
import { required } from '@validations'
import { ref } from '@vue/composition-api'
import axiosIns from '@/libs/axios'
import BaseOverlay from '@/UI/BaseOverlay.vue'
import { successNotification } from '@/utils/toast-notifications'

export default {
  components: {
    BCard,
    BaseOverlay,
    BForm,
    BFormInput,
    BSpinner,
    ValidationProvider,
    BButton,
    ValidationObserver,
    BFormGroup,
    BRow,
    // vSelect,
    BCol,
  },
  props: {
    businessId: {
      type: String,
      required: true,
    },
    isNew: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, ctx) {
    const formData = ref({
      iban: null,
      accountNumber: null,
      swift: null,
      accountOwner: null,
      bankName: null,
      accountType: null,
    })
    const formRef = ref(null)
    const fetching = ref(false)
    const businessWalletId = ref('')

    const getWalletId = async () => {
      try {
        const res = await axiosIns.get(`businesses/${props.businessId}/wallet`)
        businessWalletId.value = res.data.data.id
        console.log('Response', res)
      } catch (err) {
        console.log(err)
        // eslint-disable-next-line no-alert
        alert('Error while fetching wallet id')
      }
    }
    const payoutId = ref(null)

    const submitting = ref(false)
    const submitInfo = async () => {
      try {
        submitting.value = true
        if (!payoutId.value) {
          await ctx.root.$store.dispatch('business/createBusinessBillingInfo', {
            user_wallet_id: businessWalletId.value,
            meta: {
              ...formData.value,
            },
          })
        } else {
          await ctx.root.$store.dispatch('business/patchBusinessBillingInfo', {
            payload: {
              user_wallet_id: businessWalletId.value,
              meta: {
                ...formData.value,
              },
            },
            id: payoutId.value,
          })
        }
        successNotification('Billing updated successfully')
      } catch (err) {
        console.log(err)
        console.log(err?.response, 'Response')
      } finally {
        submitting.value = false
      }
    }

    const getBusinessBillingInfo = async () => {
      const res = await ctx.root.$store.dispatch('business/getBusinessBillingInfo', {
        id: props.businessId,
      })
      if (res.data.data.eWallet.length && res.data.data.eWallet[0].meta) {
        payoutId.value = res.data.data.eWallet[0].id
        formData.value = { ...res.data.data.eWallet[0].meta }
      }
      console.log('Response', res)
    }
    const init = async () => {
      fetching.value = true
      await getWalletId()
      if (!props.isNew) {
        await getBusinessBillingInfo()
      }
      fetching.value = false
    }
    init()
    return {
      formRef,
      fetching,
      required,
      submitInfo,
      submitting,
      formData,
    }
  },
}
</script>

<style>

</style>
